<template>
  <div class="mx-3">
    <Toast />
    <div class="card">
      <Toolbar class="mb-4">
        <template #start>
          <Button label="New" icon="pi pi-plus" class="p-button-success mr-2" @click="openNew" />
        </template>

        <template #end>
          <Button label="Export" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)" />
        </template>
      </Toolbar>

      <DataTable ref="dt" :value="subscriptions" dataKey="id" :paginator="true" :rows="10" :filters="filters"
        class="p-datatable-lg"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[5, 10, 25]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Subscriptions" responsiveLayout="scroll">
        <template #header>
          <div class="
              table-header
              flex flex-column
              md:flex-row md:justiify-content-between
            ">
            <h5 class="mb-2 md:m-0 p-as-md-center">Manage Subscriptions</h5>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText v-model="filters['global'].value" placeholder="Search..." />
            </span>
          </div>
        </template>
        <Column class="px-5" field="id" header="Id" :sortable="true" style="min-width: 10rem"></Column>
        <Column class="px-5" field="name_en" header="Name EN" :sortable="true" style="min-width: 10rem"></Column>
        <Column class="px-5" field="name_ar" header="Name Ar" :sortable="true" style="min-width: 10rem"></Column>
        <Column field="max_contacts" header="Contacts" :sortable="true" style="min-width: 10rem"></Column>
        <Column field="max_users" header="Users" :sortable="true" style="min-width: 10rem"></Column>
        <Column field="monthly_price" header="Monthly Price" :sortable="true" style="min-width: 10rem"></Column>
        <Column field="annual_price" header="Annual Price" :sortable="true" style="min-width: 10rem"></Column>
        <Column field="description_en" header="Description EN" :sortable="false" style="min-width: 14rem"></Column>
        <Column field="description_ar" header="Description AR" :sortable="false" style="min-width: 14rem"></Column>
        <Column :exportable="false" style="min-width: 10rem">
          <template #body="data">
            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mx-1 mr-2"
              @click="editSubscription(data.data)" />
            <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mx-1"
              @click="confirmDeleteSubscription(data.data)" />
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog v-model:visible="SubscriptionAddDialog" :style="{ width: '1700px' }" header="Add Subscription" :modal="true"
      class="p-fluid">
      <div class="field">
        <label for="name_en">Name EN</label>
        <InputText v-model.trim="subscription.name_en" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.name_en }" />
        <small class="p-error" v-if="submitted && !subscription.name_en">Name EN is required.</small>
      </div>
      <div class="field">
        <label for="name_ar">Name AR</label>
        <InputText v-model.trim="subscription.name_ar" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.name_ar }" />
        <small class="p-error" v-if="submitted && !subscription.name_ar">Name AR is required.</small>
      </div>
      <div class="field">
        <label for="phone">Contacts</label>

        <InputNumber mode="decimal" v-model="subscription.max_contacts" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.max_contacts }" />
        <small class="p-error" v-if="submitted && !subscription.max_contacts">Contacts Number is required.</small>
      </div>
      <div class="field">
        <label for="email">Users</label>
        <InputNumber mode="decimal" v-model="subscription.max_users" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.max_users }" />
        <small class="p-error" v-if="submitted && !subscription.max_users">Users Number is required.</small>
      </div>
      <div class="field">
        <label for="password">Monthly Price</label>
        <InputNumber mode="decimal" v-model="subscription.monthly_price" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.monthly_price }" />
        <small class="p-error" v-if="submitted && !subscription.monthly_price">Monthy Price is required.</small>
      </div>
      <div class="field">
        <label for="password">Annual Price</label>
        <InputNumber mode="decimal" v-model="subscription.annual_price" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.annual_price }" />
        <small class="p-error" v-if="submitted && !subscription.annual_price">Annual Price is required.</small>
      </div>
      <div class="field">
        <label for="name">Description EN</label>
        <Textarea v-model.trim="subscription.description_en" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.description_en }" />
        <small class="p-error" v-if="submitted && !subscription.description_en">Description EN is required.</small>
      </div>
      <div class="field">
        <label for="name">Description AR</label>
        <Textarea v-model.trim="subscription.description_ar" required="true" autofocus
          :class="{ 'p-invalid': submitted && !subscription.description_ar }" />
        <small class="p-error" v-if="submitted && !subscription.description_ar">Description AR is required.</small>
      </div>
      <div class="field ">
        <label for="description_en">Feature Description</label>
        <template v-for="(item, index) in subscription.features" :key="index">
          <div class="field row ">
            <div class="col-lg-5 mb-3">

              <InputText v-model.trim="item.description_en" required="true" autofocus placeholder="Description English"
              :class="{ 'p-invalid': submittedEdit && !item.description_en }" />
              <small class="p-error" v-if="submittedEdit && !item.description_en">Feature Description EN is
                required.</small>
            </div>
            <div class="col-lg-5">
            <InputText v-model.trim="item.description_ar" required="true" autofocus placeholder="Description Arabic"
            :class="{ 'p-invalid': submittedEdit && !item.description_ar }" />
            <small class="p-error" v-if="submittedEdit && !item.description_ar">Feature Description AR is
              required.</small>
            </div>
            <div class="col-lg-1">
              <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mx-4 mp-2" @click="deleteRow(index)" />
            </div>
          <div class="col-lg-1">
            <Button icon="pi pi-plus" v-if="index == 0" class="p-button-rounded p-button-success mx-4 mp-2"
              @click="addRow()" />
          </div>

          </div>
        </template>
      </div>
 
      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveSubscription(subscription)" />
      </template>
    </Dialog>

    <Dialog v-model:visible="SubscriptionEdiDialog" :style="{ width: '1700px' }" header="Edit Subscription" :modal="true"
      class="p-fluid">
      <div class="field">
        <label for="name_en">Name EN</label>
        <InputText v-model.trim="subscription.name_en" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.name_en }" />
        <small class="p-error" v-if="submittedEdit && !subscription.name_en">Name is required.</small>
      </div>
      <div class="field">
        <label for="name_ar">Name AR</label>
        <InputText v-model.trim="subscription.name_ar" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.name_ar }" />
        <small class="p-error" v-if="submittedEdit && !subscription.name_ar">Name is required.</small>
      </div>
      <div class="field">
        <label for="phone">Contacts</label>

        <InputNumber mode="decimal" v-model="subscription.max_contacts" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.max_contacts }" />
        <small class="p-error" v-if="submittedEdit && !subscription.max_contacts">Contacts Number is required.</small>
      </div>
      <div class="field">
        <label for="email">Users</label>
        <InputNumber mode="decimal" v-model="subscription.max_users" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.max_users }" />
        <small class="p-error" v-if="submittedEdit && !subscription.max_users">Users Number is required.</small>
      </div>
      <div class="field">
        <label for="password">Monthly Price</label>
        <InputNumber mode="decimal" v-model="subscription.monthly_price" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.monthly_price }" />
        <small class="p-error" v-if="submittedEdit && !subscription.monthly_price">Monthy Price is required.</small>
      </div>
      <div class="field">
        <label for="password">Annual Price</label>
        <InputNumber mode="decimal" v-model="subscription.annual_price" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.annual_price }" />
        <small class="p-error" v-if="submittedEdit && !subscription.annual_price">Annual Price is required.</small>
      </div>
      <div class="field">
        <label for="name">Description EN</label>
        <Textarea v-model.trim="subscription.description_en" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.description_en }" />
        <small class="p-error" v-if="submittedEdit && !subscription.description_en">Description EN is required.</small>
      </div>
      <div class="field">
        <label for="name">Description AR</label>
        <Textarea v-model.trim="subscription.description_ar" required="true" autofocus
          :class="{ 'p-invalid': submittedEdit && !subscription.description_ar }" />
        <small class="p-error" v-if="submittedEdit && !subscription.description_ar">Description AR is required.</small>
      </div>
      <div class="field ">
        <label for="description_en">Feature Description</label>
        <template v-for="(item, index) in subscription.features" :key="index">
          <div class="field row ">
            <div class="col-lg-5">

              <InputText v-model.trim="item.description_en" required="true" autofocus placeholder="Description English"
              :class="{ 'p-invalid': submittedEdit && !item.description_en }" />
              <small class="p-error" v-if="submittedEdit && !item.description_en">Feature Description EN is
                required.</small>
            </div>
            <div class="col-lg-5">
            <InputText v-model.trim="item.description_ar" required="true" autofocus placeholder="Description Arabic"
            :class="{ 'p-invalid': submittedEdit && !item.description_ar }" />
            <small class="p-error" v-if="submittedEdit && !item.description_ar">Feature Description AR is
              required.</small>
            </div>
            <div class="col-lg-1">
              <Button icon="pi pi-trash" class="p-button-rounded p-button-danger mx-4 mp-2" @click="deleteRow(index)" />
            </div>
          <div class="col-lg-1">
            <Button icon="pi pi-plus" v-if="index == 0" class="p-button-rounded p-button-success mx-4 mp-2"
              @click="addRow()" />
          </div>

          </div>
        </template>
      </div>
 

      <template #footer>
        <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="hideDialog" />
        <Button label="Save" icon="pi pi-check" class="p-button-text" @click="saveEditSubscription()" />
      </template>
    </Dialog>

    <Dialog v-model:visible="deleteSubscription" :style="{ width: '450px' }" header="Confirm" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle mx-3 text-warning" style="font-size: 3rem" />
        <span v-if="subscription"> Are you sure you want to delete <b>{{ subscription.name_en }}</b> ?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteSubscription = false" />
        <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="removeSubscription(subscription.id)" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import subscriptionService from "./service/SubscriptionService";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Dialog from "primevue/dialog";
import Toast from 'primevue/toast';
import InputText from "primevue/inputtext";
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';



export default {
  components: {
    DataTable: DataTable,
    Column: Column,
    Button: Button,
    Dialog: Dialog,
    Toolbar: Toolbar,
    InputText: InputText,
    Toast,
    InputNumber,
    Textarea
  },
  data() {
    return {
      subscriptions: null,
      SubscriptionAddDialog: false,
      deleteSubscription: false,
      subscription: {},
      filters: {},
      submitted: false,
      SubscriptionEdiDialog: false,
      submittedEdit: false,
    };
  },
  subscriptionService: null,
  created() {
    this.subscriptionService = new subscriptionService();
    this.initFilters();
  },
  mounted() {
    this.subscriptionService.getSubscriptions().then((data) => {
      this.subscriptions = data.data;
    });
  },
  methods: {
    addRow() {
      this.subscription.features.push({
        description_en: "",
        description_ar: "",
        id: 0,
      });
    },
    deleteRow(index) {
      this.subscription.features.splice(index, 1);
    },
    openNew() {
      this.subscription = {};
      this.subscription.features=[];
      this.SubscriptionAddDialog = true;
      this.addRow();
    },
    hideDialog() {
      this.SubscriptionAddDialog = false;
      this.submitted = false;
      this.SubscriptionEdiDialog = false;
      this.submittedEdit = false;
    },
    saveSubscription(subscription) {
      console.log(subscription)
      this.submitted = true;
      if (subscription.name_en && subscription.name_ar && subscription.max_contacts && subscription.max_users && subscription.annual_price && subscription.monthly_price && subscription.description_en && subscription.description_ar) {
        this.subscriptionService.addSubscription(subscription).then((data) => {
          this.submitted = false;
          this.subscriptions.push(data.data);
          this.SubscriptionAddDialog = false;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Subscription Added",
            life: 3000,
          });
        });
      }
    },
    editSubscription(subscription) {
      this.subscription = { ...subscription };
      if (this.subscription.features.length === 0) {
        this.addRow()
      }

      this.SubscriptionEdiDialog = true;
    },
    saveEditSubscription() {
      this.submittedEdit = true;
      let subscription = this.subscription 
      if (subscription.id && subscription.name_en && subscription.name_ar &&
        subscription.max_contacts && subscription.max_users && subscription.annual_price &&
        subscription.monthly_price && subscription.description_en &&
        subscription.description_ar) {
        this.subscriptionService.EditSubscription(subscription).then((data) => {
          this.subscriptions = this.subscriptions.filter(function (subscription) {
            if (subscription.id == data.data.id) {
              subscription.name_en = data.data.name_en;
              subscription.features = data.data.features ;
              subscription.name_ar = data.data.name_ar;
              subscription.monthly_price = data.data.monthly_price;
              subscription.max_users = data.data.max_users;
              subscription.max_contacts = data.data.max_contacts;
              subscription.description_en = data.data.description_en;
              subscription.description_ar = data.data.description_ar;
              subscription.annual_price = data.data.annual_price;
            }
            return subscription;
          })
          this.SubscriptionEdiDialog = false;
          this.$toast.add({
            severity: "success",
            summary: "Successful",
            detail: "Subscription Updated",
            life: 3000,
          });
        });
      }
    },

    confirmDeleteSubscription(subscription) {
      this.subscription = subscription;
      this.deleteSubscription = true;
    },
    removeSubscription(subscriptionId) {
      this.subscriptionService.removeSubscription(subscriptionId).then(() => {
        this.subscriptions = this.subscriptions.filter(subscription => subscription.id != subscriptionId);
        this.deleteSubscription = false;
        this.$toast.add({
          severity: "warn",
          summary: "Successful",
          detail: "Subscription Deleted",
          life: 3000,
        });
      });
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 960px) {
    align-items: start;
  }
}

.p-dialog .product-image {
  width: 50px;
  margin: 0 auto 2rem auto;
  display: block;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media screen and (max-width: 960px) {
  ::v-deep(.p-toolbar) {
    flex-wrap: wrap;

    .p-button {
      margin-bottom: 0.25rem;
    }
  }
}
</style>